import type { AiBudgetUsage } from '../lib/api';
import { Badge } from './ui';

/** "80% din bugetul AI" / "Buget AI depășit" — only for a Firmio subscription limit. */
export function AiBudgetBadge({ usage }: { usage: AiBudgetUsage | null }) {
  if (!usage || usage.level === 'ok') return null;
  return usage.level === 'over' ? (
    <Badge color="red">Buget AI depășit ({usage.pct}%)</Badge>
  ) : (
    <Badge color="amber">{usage.pct}% din bugetul AI</Badge>
  );
}
